var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9993 0V5.45488H6.54492V0H11.9993ZM7.63538 4.36431H10.9088V1.09056H7.63538V4.36431Z",
    fill: "#00917D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45434 0V5.45488H0V0H5.45434ZM1.09046 4.36431H4.36388V1.09056H1.09046V4.36431Z",
    fill: "#00917D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9993 6.54492V9.81661H10.9521V8.73017L9.86164 8.72811V9.81661H8.72583V8.72605H7.63538V11.9998H6.54492V6.54492H7.57972V7.61281L8.67018 7.61487V6.54492H9.81629V7.63548H10.9088V6.54492H11.9993Z",
    fill: "#00917D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0006 10.9093V11.9999H10.9102V10.9072L12.0006 10.9093Z",
    fill: "#00917D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.81702 10.9093V11.9999H8.72656V10.9072L9.81702 10.9093Z",
    fill: "#00917D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45434 6.54492V11.9998H0V6.54492H5.45434ZM1.09046 10.8989H4.36388V7.63548H1.09046V10.8989Z",
    fill: "#00917D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3496 1.64697V3.80542H8.19141V1.64697H10.3496Z",
    fill: "#00917D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.80472 8.19287V10.3513H1.64648V8.19287H3.80472Z",
    fill: "#00917D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.80472 1.64697V3.80542H1.64648V1.64697H3.80472Z",
    fill: "#00917D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeIcon);
export default __webpack_public_path__ + "static/media/QRCodeIcon.00beada29fd8e8d377af6121c051d2fa.svg";
export { ForwardRef as ReactComponent };